<script setup>
import { scaleQuantity, renderStep } from '../lib/quantity'

// Cooking-for-Engineers table: cell placement is precomputed server-side by
// FlowLayout; this component only paints cells and scales quantities.
const props = defineProps({
  flow: { type: Object, required: true }, // { rows, cols, cells }
  ingredientsByKey: { type: Object, required: true },
  baseServes: { type: Number, default: 4 },
  target: { type: Number, required: true },
})

function cellStyle(c) {
  return {
    gridRow: `${c.row} / span ${c.rowSpan}`,
    gridColumn: `${c.col} / span ${c.colSpan}`,
  }
}

const kindClasses = {
  prep: 'justify-center italic opacity-80',
  op: 'justify-center text-center font-medium',
  ingredient: '',
  filler: '',
}

function ingredientText(c) {
  const ing = props.ingredientsByKey[c.key]
  if (!ing) return ''
  const qty = scaleQuantity(ing.quantity, props.baseServes, props.target)
  return [qty, ing.unit, ing.item].filter(Boolean).join(' ') + (ing.note ? `, ${ing.note}` : '')
}

function opText(c) {
  return renderStep(c.label, props.ingredientsByKey, props.baseServes, props.target)
}
</script>

<template>
  <div class="overflow-x-auto">
    <div
      class="grid border-2 border-base-content/70 rounded-box overflow-hidden min-w-[36rem]"
      :style="{ gridTemplateColumns: `minmax(11rem, 2fr) repeat(${flow.cols - 1}, minmax(3.5rem, 1fr))` }"
    >
      <div
        v-for="(c, i) in flow.cells"
        :key="i"
        class="border border-base-content/25 px-3 py-2 flex items-center leading-snug"
        :class="kindClasses[c.kind]"
        :style="cellStyle(c)"
      >
        <template v-if="c.kind === 'ingredient'">{{ ingredientText(c) }}</template>
        <template v-else-if="c.kind === 'op' || c.kind === 'prep'">{{ opText(c) }}</template>
      </div>
    </div>
  </div>
</template>
